type Props = {
  variant?: 'loading' | 'error' | 'empty';
  message?: string;
};

export function StateMessage({ variant = 'loading', message }: Props) {
  const defaults: Record<NonNullable<Props['variant']>, string> = {
    loading: 'Chargement…',
    error: 'Une erreur est survenue.',
    empty: 'Aucun résultat.',
  };
  return (
    <div className="mtc-state">
      <span className="mtc-state-eyebrow">{variant.toUpperCase()}</span>
      <p>{message ?? defaults[variant]}</p>
    </div>
  );
}
